import React from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import HomePgBackground from "../../Images/HomePg-Background.webp";
import ServicesOverview from "./ServiceOverviewSection";
import SaudiInvestmentSections from "./SaudiInvestmentSection";
import HomeContactForm from "./HomeContactForm";
import WhySemarsHoldings from "./WhySemarsHoldings";
import "../.././App.css";

const MainPage = () => {
  return (
    <div>
      <Header />
      <section
        className="relative w-full min-h-screen text-white bg-no-repeat bg-[position:70%] bg-cover sm:bg-top"
        style={{
          backgroundImage: `url(${HomePgBackground})`,
        }}
      >
        <div className="pt-[10rem]" data-aos="fade-up">
          <section className="pb-12 px-6 bg-transparent text-gray-800">
            <div className="text-left mb-12 max-w-7xl mx-auto">
              <h2 className="text-3xl md:text-5xl lg:text-7xl font-semibold text-[#000000]">
                Unlock
              </h2>
              <h2 className="text-3xl md:text-5xl lg:text-7xl font-semibold text-[#000000]">
                Opportunities in the
              </h2>
              <h2 className="text-3xl md:text-5xl lg:text-7xl font-semibold text-[#000000]">
                Heart of the Middle{" "}
              </h2>
              <h2 className="text-3xl md:text-5xl lg:text-7xl font-semibold text-[#000000]">
                East
              </h2>
              <p className="text-xl text-[#000000] py-2 md:py-16 max-w-2xl font-normal">
              Luxury business advisory & investment support for international companies entering Saudi Arabia.
              </p>
            </div>
          </section>
          <div className="relative">
            <div
              className="absolute top-[180px] left-1/2 transform -translate-x-1/2 z-20 animate-pulse cursor-pointer"
              onClick={() =>
                window.scrollBy({
                  top: window.innerHeight * 1.5,
                  behavior: "smooth",
                })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 60"
                className="w-6 h-6 fill-[#000000]"
              >
                <polygon points="50,60 0,0 100,0" />
              </svg>
            </div>
            <div className="h-10"></div>
            <section className="relative min-h-[50vh] flex items-center bg-[#000000B2] z-10 clip-v-shape">
              <div className="relative z-10 container mx-auto pt-24 md:pt-32">
                <div className="max-w-4xl mx-auto text-center pt-40">
                  <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white mb-8 md:mb-12">
                    Semars Holding
                  </h1>
                  <div className="max-w-3xl mx-auto px-4 md:px-0">
                    <p className="text-lg md:text-xl lg:text-2xl text-gray-200 leading-relaxed">
                    Semars Holding is a premier advisory and investment consulting firm headquartered in Jeddah,
                    Saudi Arabia. We help global investors and corporations thrive in one of the world’s
                    fastest-growing economies, delivering tailored strategies and complete in-Kingdom solutions.
                    </p>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
      <WhySemarsHoldings />
      <ServicesOverview />
      <SaudiInvestmentSections />
      <HomeContactForm />
      <Footer />
    </div>
  );
};

export default MainPage;
